import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const targetTime = new Date().getTime() + 23 * 60 * 60 * 1000 + 59 * 60 * 1000 + 59 * 1000;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetTime - now;
      if (difference <= 0) {
        clearInterval(interval);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      } else {
        setTimeLeft({
          hours: Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(difference % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(difference % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="flex justify-center items-center space-x-2 md:space-x-4 text-3xl md:text-5xl font-bold text-red-600 font-serif" data-id="element-32">
      <div className="flex flex-col items-center bg-white px-4 py-3 rounded-xl shadow-sm border border-red-100 min-w-[80px]" data-id="element-33">
        <span data-id="element-34">{formatTime(timeLeft.hours)}</span>
        <span className="text-xs font-sans text-red-400 uppercase tracking-wider mt-1" data-id="element-35">
          Horas
        </span>
      </div>
      <span className="text-red-400 pb-6" data-id="element-36">:</span>
      <div className="flex flex-col items-center bg-white px-4 py-3 rounded-xl shadow-sm border border-red-100 min-w-[80px]" data-id="element-37">
        <span data-id="element-38">{formatTime(timeLeft.minutes)}</span>
        <span className="text-xs font-sans text-red-400 uppercase tracking-wider mt-1" data-id="element-39">
          Min
        </span>
      </div>
      <span className="text-red-400 pb-6" data-id="element-40">:</span>
      <div className="flex flex-col items-center bg-white px-4 py-3 rounded-xl shadow-sm border border-red-100 min-w-[80px]" data-id="element-41">
        <span data-id="element-42">{formatTime(timeLeft.seconds)}</span>
        <span className="text-xs font-sans text-red-400 uppercase tracking-wider mt-1" data-id="element-43">
          Seg
        </span>
      </div>
    </div>;
}